import { render, staticRenderFns } from "./DoctorPriceBlockByType.vue?vue&type=template&id=0255112a&scoped=true&"
import script from "./DoctorPriceBlockByType.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPriceBlockByType.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorPriceBlockByType.vue?vue&type=style&index=0&id=0255112a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255112a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0255112a')) {
      api.createRecord('0255112a', component.options)
    } else {
      api.reload('0255112a', component.options)
    }
    module.hot.accept("./DoctorPriceBlockByType.vue?vue&type=template&id=0255112a&scoped=true&", function () {
      api.rerender('0255112a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/DoctorPriceBlockByType.vue"
export default component.exports